import { lazy, Suspense, useEffect, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Bell } from 'lucide-react';
import { t } from '../../i18n/index.js';
import { useUnread } from '../../platform/queries.js';
import { Sheet } from '../../ui/Sheet.js';
import { LoadError, ViewSkeleton } from '../../ui/Skeleton.js';
import { Button } from '../../ui/ui.js';

/**
 * Persönlicher Eingang (Paket P6): Erwähnungen, Zuweisungen, Kommentare und Erledigtes bei gefolgten Aufgaben.
 * Ein Fenster über der aktuellen Seite – kein eigener Ort neben Lobby, Mein Tag und Befehlspalette (Insel-Prinzip).
 */
/** Inhalt des Eingangs erst beim Öffnen laden (Startpaket) */
const InboxBody = lazy(() => import('./InboxPanel.js'));

export function InboxButton() {
  const [open, setOpen] = useState(false);
  const unread = useUnread(true).data?.unread ?? 0;
  // Auch aus der Befehlspalette zu öffnen
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener('werft:inbox', onOpen);
    // P23: Link aus der E-Mail-Zusammenfassung (/?eingang=1) öffnet den Eingang
    const url = new URL(location.href);
    if (url.searchParams.has('eingang')) {
      url.searchParams.delete('eingang');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      setOpen(true);
    }
    return () => window.removeEventListener('werft:inbox', onOpen);
  }, []);
  return (
    <>
      <Button variant="ghost" onClick={() => setOpen(true)} aria-label={unread ? t('inbox.open', { n: unread }) : t('inbox.openNone')} className="relative">
        <Bell className="size-4" aria-hidden />
        {unread > 0 && (
          <span aria-hidden className="absolute top-1 right-1 grid min-w-4 place-items-center rounded-full bg-[var(--color-accent)] px-1 text-[10px] leading-4 font-semibold text-on-accent">
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </Button>
      <Sheet open={open} onClose={() => setOpen(false)} title={t('inbox.title')}>
        {open && (
          <Suspense fallback={<ViewSkeleton kind="list" />}>
            <InboxBody onClose={() => setOpen(false)} />
          </Suspense>
        )}
      </Sheet>
    </>
  );
}

